import { Home, Sun, Droplet, Droplets, Recycle, Move, TreeDeciduous, DoorOpen, Tractor, Cloud } from "lucide-react";

/**
 * Visual + behavioural definitions for each Structure type.
 * Each token has:
 *   - icon: lucide component
 *   - bg / border / text: tailwind arbitrary color classes (earthy palette)
 *   - label: short user-facing name
 *   - default_length_cm / default_width_cm: sensible starting size
 *   - default_props: type-specific property scaffolding for the edit dialog
 */
export const STRUCTURE_TOKENS = {
    shed: {
        icon: Home, label: "Shed",
        bg: "bg-[#D6BFA1]", border: "border-[#8C6A5D]", text: "text-[#3B3228]",
        default_length_cm: 250, default_width_cm: 200,
        default_props: { stores_tools: true },
    },
    greenhouse: {
        icon: Sun, label: "Greenhouse",
        bg: "bg-[#F5E5C0]", border: "border-[#D99A45]", text: "text-[#6B4A14]",
        default_length_cm: 300, default_width_cm: 250,
        default_props: { glazed: true },
    },
    polytunnel: {
        icon: Cloud, label: "Polytunnel",
        bg: "bg-[#D7E1CA]", border: "border-[#A3B19B]", text: "text-[#2C3625]",
        default_length_cm: 500, default_width_cm: 300,
        default_props: { material: "polythene" },
    },
    water_tank: {
        icon: Droplet, label: "Water Tank",
        bg: "bg-[#C6D8E3]", border: "border-[#5C7E96]", text: "text-[#1F3B52]",
        default_length_cm: 100, default_width_cm: 100,
        default_props: { capacity_liters: 1000, source: "rainwater" },
    },
    water_butt: {
        icon: Droplets, label: "Water Butt",
        bg: "bg-[#D8E5EC]", border: "border-[#5C7E96]", text: "text-[#1F3B52]",
        default_length_cm: 60, default_width_cm: 60,
        default_props: { capacity_liters: 210, source: "rainwater" },
    },
    compost_bin: {
        icon: Recycle, label: "Compost Bin",
        bg: "bg-[#C9B98D]", border: "border-[#8C6A5D]", text: "text-[#3B3228]",
        default_length_cm: 100, default_width_cm: 100,
        default_props: { stage: "active" },
    },
    path: {
        icon: Move, label: "Path",
        bg: "bg-[#E6DCC4]", border: "border-[#B5A98A]", text: "text-[#5C4530]",
        default_length_cm: 400, default_width_cm: 60,
        default_props: { material: "gravel" },
    },
    tree: {
        icon: TreeDeciduous, label: "Tree",
        bg: "bg-[#B7C8A8]", border: "border-[#4A6741]", text: "text-[#2C3625]",
        default_length_cm: 200, default_width_cm: 200,
        default_props: { species: "" },
    },
    gate: {
        icon: DoorOpen, label: "Gate",
        bg: "bg-[#D6C4AE]", border: "border-[#8C6A5D]", text: "text-[#3B3228]",
        default_length_cm: 100, default_width_cm: 20,
        default_props: { opens: "outward" },
    },
};

export const STRUCTURE_TYPES = Object.keys(STRUCTURE_TOKENS);

export const structureToken = (type) => STRUCTURE_TOKENS[type] || STRUCTURE_TOKENS.shed;

// Bed visual token — distinct from structures so it stands out on the map
export const BED_TOKEN = {
    bg: "bg-[#EDE3CC]",
    border: "border-[var(--vm-accent)]",
    text: "text-[var(--vm-text)]",
    label: "Bed",
    icon: Tractor,
};
